import { FormatArray } from "../../Utils/utils";
import { sessionReportTitle } from "./SessionReport";

const AssessmentRecommendationSubthreshold = () => {
    return (<>
        <span style={sessionReportTitle}>
            Assessment Recommendation Summary
        </span>
        <ul>
            <li key="Principal Clinical Findings">
                <strong>Principal Clinical Findings:</strong>
            </li>
            <FormatArray
                subIndex={"code"}
                keyName="ICD-10 CM code"
                value=" "
            />
        </ul>
        <span style={sessionReportTitle}>
            Assessment Recommendation Details
        </span>

        <h3 style={{ marginLeft: "20px" }}>
            Substance Use Disorder
        </h3>
        <ul>
            <li key="Principal Clinical Findings">
                <strong>Principal Clinical Findings:</strong>
            </li>
            <FormatArray
                subIndex={"code"}
                keyName="ICD-10 CM code"
                value=" "
            />
            <FormatArray
                subIndex={"substance"}
                keyName="Main Substance"
                value=" "
            />
            <FormatArray
                subIndex={"secondary_diagnosis"}
                keyName="Other Substances"
                value=" "
            />
            <FormatArray
                subIndex={"severity"}
                keyName="Severity"
                value=" "
            />
            <FormatArray
                subIndex={"substance"}
                keyName="Frameworks"
                value=" "
            />
        </ul>
        <span
            style={{
                ...sessionReportTitle,
            }}
        >
            References for Clinical Findings
        </span>
        <span
            style={{
                ...sessionReportTitle,
                backgroundColor: "#faf7dc",
                marginTop: "10px",
            }}
        >
            References for Principal Clinical Findings
        </span>

        <h3 style={{ marginLeft: "20px" }}>
            Substance Use Disorder
        </h3>
        <ul>
            <FormatArray
                subIndex={"1_dsm_control_usage"}
                keyName="Impaired Control - Usage"
                value=" "
            />
            <FormatArray
                subIndex={"2_dsm_control_desire"}
                keyName="Impaired Control - Desire To Cut Down"
                value=" "
            />
            <FormatArray
                subIndex={"3_dsm_control_commitment"}
                keyName="Impaired Control - Time Commitment"
                value=" "
            />
            <FormatArray
                subIndex={"4_dsm_control_arduous"}
                keyName="Impaired Control - Craving"
                value=" "
            />
            <FormatArray
                subIndex={"5_dsm_social_failure"}
                keyName="Social Impairment - Failure"
                value=" "
            />
            <FormatArray
                subIndex={"6_dsm_social_persistence"}
                keyName="Social Impairment - Persistence"
                value=" "
            />
            <FormatArray
                subIndex={"7_dsm_social_decline"}
                keyName="Social Impairment - Decline"
                value=" "
            />
            <FormatArray
                subIndex={"8_dsm_risk_hazard"}
                keyName="Risky Use - Hazard"
                value=" "
            />
            <FormatArray
                subIndex={"9_dsm_risk_tenacity"}
                keyName="Risky Use - Tenacity"
                value=" "
            />
            <FormatArray
                subIndex={"10_dsm_tolerance"}
                keyName="Tolerance"
                value=" "
            />
            <FormatArray
                subIndex={"10_a_dsm_tolerance_dosage_increase"}
                keyName="Tolerance - Dosage Increase"
                value=" "
            />
            <FormatArray
                subIndex={"11_dsm_withdrawal"}
                keyName="Withdrawal"
                value=" "
            />
            <FormatArray
                subIndex={"11_a_dsm_withdrawal_relief"}
                keyName="Withdrawal - Relief"
                value=" "
            />
            <FormatArray
                subIndex={"11_b_dsm_withdrawal_symptoms"}
                keyName="Withdrawal - Symptoms"
                value=" "
            />
        </ul>
    </>)
}


export default AssessmentRecommendationSubthreshold;